import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { actions as systemActions } from "../store/slices/systemSlice.js";
import { asyncActions as asyncDictionaryActions } from "../store/slices/dictionarySlice.js";
import { asyncActions as asyncSystemActions } from "../store/slices/systemSlice.js";
import { actions as errorActions } from "../store/slices/globalErrorSlice.js";
import ls from "../utility/ls.js";

const cookieLSConst = "cookiesAccepted";

const useSystem = ({ env }) => {
  const upperEnv = env.toUpperCase();
  //////////////////////////////////////////dispatcher
  const dispatch = useDispatch();

  const [cookiesAccepted, setCookiesAccepted] = useState(false);

  //////////////////////////////////////////redux state
  const systemState = useSelector((state) => state.systemState);
  const dictionaryState = useSelector((state) => state.dictionaryState);

  //////////////////////////////////////////effects

  /***
   *      _                                                  _                            _   _   _                    __      _       _           _             _           _
   *     | |_ _   _ _ __ _ __     ___  _ __    ___ _   _ ___| |_ ___ _ __ ___    ___  ___| |_| |_(_)_ __   __ _ ___   / _| ___| |_ ___| |__    ___| |_ __ _ _ __| |_ ___  __| |
   *     | __| | | | '__| '_ \   / _ \| '_ \  / __| | | / __| __/ _ \ '_ ` _ \  / __|/ _ \ __| __| | '_ \ / _` / __| | |_ / _ \ __/ __| '_ \  / __| __/ _` | '__| __/ _ \/ _` |
   *     | |_| |_| | |  | | | | | (_) | | | | \__ \ |_| \__ \ ||  __/ | | | | | \__ \  __/ |_| |_| | | | | (_| \__ \ |  _|  __/ || (__| | | | \__ \ || (_| | |  | ||  __/ (_| |
   *      \__|\__,_|_|  |_| |_|  \___/|_| |_| |___/\__, |___/\__\___|_| |_| |_| |___/\___|\__|\__|_|_| |_|\__, |___/ |_|  \___|\__\___|_| |_| |___/\__\__,_|_|   \__\___|\__,_|
   *                                               |___/                                                  |___/
   */

  useEffect(() => {
    dispatch(systemActions.setSystemSettingsFetchStartedToTrue());
  }, []);

  /***
   *       ___  ____
   *      / _ \/ ___|
   *     | | | \___ \
   *     | |_| |___) |
   *      \___/|____/
   *
   */
  {
    useEffect(() => {
      dispatch(systemActions.setSystemOS({ OS: env }));
    }, []);
  }
  /***
   *                          _   _ _   _
   *       __ _ _ __  _ __   | |_(_) |_| | ___
   *      / _` | '_ \| '_ \  | __| | __| |/ _ \
   *     | (_| | |_) | |_) | | |_| | |_| |  __/
   *      \__,_| .__/| .__/   \__|_|\__|_|\___|
   *           |_|   |_|
   */
  {
    useEffect(() => {
      if (upperEnv === "WEB") {
        document.title = process.env.REACT_APP_TITLE;
      }
    }, []);
  }
  /***
   *      _   _
   *     | |_| |__   ___ _ __ ___   ___
   *     | __| '_ \ / _ \ '_ ` _ \ / _ \
   *     | |_| | | |  __/ | | | | |  __/
   *      \__|_| |_|\___|_| |_| |_|\___|
   *
   */
  {
    useEffect(() => {
      const asyncSetTheme = async () => {
        let themeFromLS;
        if (upperEnv === "WEB") {
          themeFromLS = ls.getFromLs({ key: "theme" });
        } else {
          themeFromLS = await ls.getFromLs({ key: "theme" });
        }
        themeFromLS = JSON.parse(themeFromLS)?.theme;
        dispatch(systemActions.setSystemTheme({ theme: themeFromLS }));
      };
      asyncSetTheme();
    }, []);
  }

  /***
   *      _
   *     | | __ _ _ __   __ _ _   _  __ _  __ _  ___
   *     | |/ _` | '_ \ / _` | | | |/ _` |/ _` |/ _ \
   *     | | (_| | | | | (_| | |_| | (_| | (_| |  __/
   *     |_|\__,_|_| |_|\__, |\__,_|\__,_|\__, |\___|
   *                    |___/             |___/
   */
  //////////////////////////////////////////loada jezike

  useEffect(() => {
    const processId = dispatch(
      systemActions.addToSystemSettingsBucket({
        processName: "getting translations",
      })
    ).payload.processId; //uključi process (loading)

    const dictionaryPromise = dispatch(
      asyncDictionaryActions.getTranslations()
    );
    //idi po dictionary na serer

    const afterPromise = async () => {
      const res = await dictionaryPromise;

      let langFromLs;

      if (upperEnv === "WEB") {
        langFromLs = ls.getFromLs({ key: "lang" });
      } else {
        langFromLs = await ls.getFromLs({ key: "lang" });
      }

      langFromLs = JSON.parse(langFromLs)?.lang;

      if (!res.error) {
        const primaryLang = res.payload.items[0].primary_lang;
        let langToSet = langFromLs ?? primaryLang;

        const allLanguages = [
          res.payload.items[0].primary_lang,
          res.payload.items[0].secondary_lang,
        ]; //potegni sve jezike iz promisa

      
        if (!allLanguages.includes(langToSet)) {
          langToSet = primaryLang;
        }

        console.log("langToSet", langToSet);
        dispatch(systemActions.setSystemLanguage({ lang: langToSet }));

        //namjesti jezik ako jezik s local storage-a nije na popisu jezika   na primary sa servera

        dispatch(
          systemActions.removeFromSettingsBucket({ processId: processId })
        );
      }
    };
    afterPromise();

    return () => {
      dispatch(
        systemActions.removeFromSettingsBucket({ processId: processId })
      );
      dictionaryPromise.abort();
    };
  }, []);

  //provjera jezika
  const isDictionaryLoaded = dictionaryState.dictionaryLoaded;
  const numberOfLanguages = dictionaryState.languages.length;

  useEffect(() => {
    if (isDictionaryLoaded === true) {
      if (numberOfLanguages === 0) {
        dispatch(
          errorActions.raiseGlobalError({
            msg: "notEnoughLanguages",
          })
        );
      }
      //digni error ako nema ni jedan jezik na serveru

      const hasPrimaryLang =
        Object.entries(dictionaryState.translations).filter((element) => {
          return element[1].isPrimaryLang;
        }).length > 0;

      if (hasPrimaryLang === false) {
        dispatch(
          errorActions.raiseGlobalError({
            msg: "noPrimaryLanguage",
          })
        );
      }
    }
    //digni error ako nema ucitani primary lang
  }, [isDictionaryLoaded, numberOfLanguages]);

  /***
   *                                   _   _   _
   *       __ _ _ __  _ __    ___  ___| |_| |_(_)_ __   __ _ ___
   *      / _` | '_ \| '_ \  / __|/ _ \ __| __| | '_ \ / _` / __|
   *     | (_| | |_) | |_) | \__ \  __/ |_| |_| | | | | (_| \__ \
   *      \__,_| .__/| .__/  |___/\___|\__|\__|_|_| |_|\__, |___/
   *           |_|   |_|                               |___/
   */
  useEffect(() => {
    const processId = dispatch(
      systemActions.addToSystemSettingsBucket({
        processName: "getting system settings",
      })
    ).payload.processId;

    const settingsPromise = dispatch(asyncSystemActions.getSystemSettings());

    const afterPromise = async () => {
      await settingsPromise;

      dispatch(
        systemActions.removeFromSettingsBucket({ processId: processId })
      );
    };
    afterPromise();

    return () => {
      dispatch(
        systemActions.removeFromSettingsBucket({ processId: processId })
      );
      settingsPromise.abort();
    };
  }, []);

  /***
   *                      _    _
   *       ___ ___   ___ | | _(_) ___  ___
   *      / __/ _ \ / _ \| |/ / |/ _ \/ __|
   *     | (_| (_) | (_) |   <| |  __/\__ \
   *      \___\___/ \___/|_|\_\_|\___||___/
   *
   */

  useEffect(() => {
    if (upperEnv === "WEB") {
      let currentCookieState = null;
      try {
        currentCookieState = JSON.parse(ls.getFromLs({ key: cookieLSConst }));
      } catch (err) {}

      if (
        currentCookieState === null ||
        ![true, false].includes(currentCookieState)
      ) {
        ls.addToLs({ key: cookieLSConst, value: false });
      }

      currentCookieState = JSON.parse(ls.getFromLs({ key: cookieLSConst }));
      setCookiesAccepted(currentCookieState);
    }
  }, []);

  const acceptCookies = () => {
    ls.addToLs({ key: cookieLSConst, value: true });
    setCookiesAccepted(true);
  }; //ovo je samo na webu

  /***
   *      __  __    _    _   _ ___ _____ _____ ____ _____
   *     |  \/  |  / \  | \ | |_ _|  ___| ____/ ___|_   _|
   *     | |\/| | / _ \ |  \| || || |_  |  _| \___ \ | |
   *     | |  | |/ ___ \| |\  || ||  _| | |___ ___) || |
   *     |_|  |_/_/   \_\_| \_|___|_|   |_____|____/ |_|
   *
   */
  const manifestName = process.env.REACT_APP_MANIFEST_NAME;

  useEffect(() => {
    let manifestLink;
    let faviconLink;
    let appleTouchIcon;
    if (upperEnv === "WEB") {
      fetch(`/${manifestName}`)
        .then((response) => response.json())
        .then((data) => {
          // Access and use the manifest data

          const linkElement = document.getElementById("firstIconLink");
          if (linkElement) {
            linkElement.remove();
          }

          manifestLink = document.createElement("link");
          manifestLink.rel = "manifest";
          manifestLink.href = `/${manifestName}`;
          document.head.appendChild(manifestLink);

          faviconLink = document.createElement("link");
          faviconLink.rel = "icon";
          console.log(`/${data.icons[0].src}`)
          faviconLink.href = `/${data.icons[0].src}`;
          document.head.appendChild(faviconLink);

          appleTouchIcon = document.createElement("link");
          appleTouchIcon.rel = "apple-touch-icon";
          appleTouchIcon.href = `/${data.icons[1].src}`;
          document.head.appendChild(appleTouchIcon);
        })
        .catch((error) => {
          console.error("NO MANIFEST");
        });
    }

    return () => {
      if (upperEnv === "WEB") {
        if (manifestLink) {
          document.head.removeChild(manifestLink);
        }

        if (faviconLink) {
          document.head.removeChild(faviconLink);
        }

        if (appleTouchIcon) {
          document.head.removeChild(appleTouchIcon);
        }
      }
    };
  }, []);

  return { cookiesAccepted, acceptCookies };
};

export default useSystem;

{
  /* <link rel="apple-touch-icon" href="%PUBLIC_URL%/logo192.png" /> */
}
